const dimensions = {
    phone: { width: 390, height: 844 },
    tablet_mini: { width: 768, height: 1024 },
    tablet: { width: 1024, height: 1366 },
    laptop: { width: 1440, height: 747 },
    desktop: { width: 1920, height: 963 }
}

export default dimensions;